import types  from "../types/types";

export const idConvocatorias = (idConvocatoria: number) => ({
  type: types.idConvocatoria,
  payload: {
    idConvocatoria,
  },
});

export const edicionConvocatoria = (editarConvocatoria: boolean) => ({
  type: types.edicion,
  payload: {
    editarConvocatoria,
  },
});

export const cambiarPestaña = (cambiarPestaña: string) => ({
  type: types.cambiarPestaña,
  payload: {
    cambiarPestaña,
  },
});
